export function addCurrent(user) {
    return {
        type: 'ADD_CURRENT',
        user,
    }
}
